import React, { useState } from 'react';
import './styles/global.css';

import Header from './components/layout/Header';
import TabBar from './components/layout/TabBar';
import TabPanel from './components/layout/TabPanel';

import DigitsSumExercise from './components/exercises/DigitsSumExercise';
import IsPalindromeExercise from './components/exercises/IsPalindromeExercise';
import IntegerSortExercise from './components/exercises/IntegerSortExercise';

import { TABS } from './constants/tabs';
import styles from './App.module.css';

const EXERCISE_MAP = {
  digitsSum:    <DigitsSumExercise />,
  isPalindrome: <IsPalindromeExercise />,
  integerSort:  <IntegerSortExercise />,
};

function App() {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const currentTab = TABS.find((t) => t.id === activeTab);

  return (
    <div className={styles.app}>
      <Header />
      <main className={styles.main}>
        <TabBar tabs={TABS} activeId={activeTab} onSelect={setActiveTab} />
        <TabPanel tab={currentTab}>
          {EXERCISE_MAP[activeTab]}
        </TabPanel>
      </main>
      <footer className={styles.footer}>
        <span>JavaScript · Bubble Sort · Two Pointers · Aritmética modular</span>
      </footer>
    </div>
  );
}

export default App;
